import { baseData } from "./base.model";

export class ClubhouseData extends baseData {
    presentationsReviewed = [] as {val: string, time: Date}[];

    constructor() {
        super('clubhouse');
    }
}